import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const StyledButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 9px;

  button {
    display: inline-block;
    margin: 0;
    margin-left: 15px;
    min-width: 47px;

    &:not(.previous) {
      background-color: ${colors.blue1};
    }
  }

  .previous {
    border: none;
    padding: 0;
    cursor: pointer;
  }
`;
